var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('upper-navbar',{attrs:{"account-links":_vm.accountLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }